import {parseCookies} from 'nookies'
import stringHash from 'string-hash'
import useCustomer from '_app/hooks/useCustomer'

export const useUserToken = () => {
  const { customer } = useCustomer()
  const { _ALGOLIA } = parseCookies() ?? {}
  return customer?.email ? stringHash(customer.email).toString() : _ALGOLIA
}